export const navItems = [
  { label: '亲历者口述', href: '#timeline' },
  { label: '经历与细节', href: '#stories' },
  { label: '骗局识别', href: '#scheme' },
  { label: '警示问答', href: '#faq' },
  { label: '资源入口', href: '#entry' },
];

export const heroStats = [
  { value: '128', label: '收录亲历者口述' },
  { value: '9', label: '常见诱骗类型' },
  { value: '64', label: '逃生与求助要点' },
];

export const metricStrip = [
  { value: '3 步', label: '出境前风险自查' },
  { value: '9 类', label: '高薪招工话术' },
  { value: '128 篇', label: '亲历者口述自述' },
  { value: '24 小时', label: '求助信息整理更新' },
];

export const entries = [
  {
    icon: 'ri-file-text-line',
    title: '口述档案合集',
    desc: '亲历者完整自述与经历时间线，按出境地与被困阶段分类整理。',
    tag: '文字 · 音频',
    href: '#timeline',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: '骗局识别清单',
    desc: '把招工话术逐条拆开，对照真实案例标注其中的可疑信号。',
    tag: '清单',
    href: '#scheme',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '被困自救要点',
    desc: '出境前后的行动建议与联络方式梳理，尽量降低自身风险。',
    tag: '指引',
    href: '#faq',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '求助与通报通道',
    desc: '面向本人与家属的可用求助途径，以及信息整理的关键要素。',
    tag: '通道',
    href: '#cta',
  },
  {
    icon: 'ri-route-line',
    title: '逃生过程复盘',
    desc: '已脱身者还原的关键节点、路线与时间线复盘，供后人参考。',
    tag: '复盘',
    href: '#stories',
  },
  {
    icon: 'ri-clipboard-line',
    title: '目的地风险自查',
    desc: '出发前逐项核对的中高风险区域与用工信息自查表。',
    tag: '自查',
    href: '#cta',
  },
];

export const timeline = [
  {
    date: '3 月 12 日',
    title: '一份写着“月薪两万”的招工启事',
    narrator: '口述者：阿哲 · 21 岁',
    tag: '诱骗',
    summary:
      '他在短视频私信里被推荐到境外从事“数据录入”，对方承诺包机票与住宿。直到落地后手机被统一收走，他才第一次意识到事情不对。',
  },
  {
    date: '4 月 02 日',
    title: '“公司”门口的保安换了人',
    narrator: '口述者：小梁 · 24 岁',
    tag: '被困',
    summary:
      '进入所谓园区后，出入需要登记，护照被“代为保管”。他后来回忆，那是自己第一次真正意识到人身自由正在被一点点收紧。',
  },
  {
    date: '5 月 18 日',
    title: '被要求背熟的那本话术手册',
    narrator: '口述者：匿名 · 19 岁',
    tag: '被迫',
    summary:
      '每天要记熟一整套聊天话术，完不成指标就会被孤立、扣掉生活费。他说，最难受的不是累，而是知道自己正在成为伤害别人的一环。',
  },
  {
    date: '6 月 27 日',
    title: '一次换园区带来的转机',
    narrator: '口述者：阿凯 · 22 岁',
    tag: '转机',
    summary:
      '转运途中看守出现松懈，他记住了沿途的路牌、加油站与大致耗时，这些细节成了后来判断方位、等待机会的重要依据。',
  },
  {
    date: '8 月 09 日',
    title: '凌晨四点打出去的那通电话',
    narrator: '口述者：匿名 · 26 岁',
    tag: '逃生',
    summary:
      '他趁夜联系上家人并发送了位置，家属同步整理聊天与转账记录，最终配合完成了整套求助流程。',
  },
  {
    date: '9 月 01 日',
    title: '回国之后，他把经历写了下来',
    narrator: '口述者：受访者集体',
    tag: '复盘',
    summary:
      '多位脱身者把细节口述整理成文档，希望后来的求职者在出发之前就能看到这份警示，而不是等到落地后才明白。',
  },
];

export const stories = [
  {
    name: '阿凯',
    meta: '21 岁 · 电焊工',
    place: '曾在妙瓦底被困 4 个月',
    summary: '从“包吃住高薪招工”到失去自由，他记住了每一天的作息与细节，也记住了那条通往自由的路线。',
    tags: ['高薪招工', '限制自由'],
    img: 'https://readdy.ai/api/search-image?query=Stylized%20documentary%20still%20life%20of%20a%20worn%20notebook%2C%20a%20pen%20and%20a%20closed%20cardboard%20folder%20on%20a%20wooden%20table%20under%20warm%20lamp%20light%2C%20muted%20amber%20and%20brown%20tones%2C%20soft%20grain%2C%20quiet%20editorial%20photography%2C%20no%20people%2C%20calm%20and%20restrained%20mood&width=800&height=600&seq=mnhl-story-01&orientation=landscape',
  },
  {
    name: '小梁',
    meta: '24 岁 · 应届毕业生',
    place: '曾在边境园区滞留 2 个月',
    summary: '一条私信推荐，一张单程机票。他的口述还原了从线上面试、承诺待遇，到真正出境的全过程。',
    tags: ['私信推荐', '代管证件'],
    img: 'https://readdy.ai/api/search-image?query=Stylized%20foggy%20mountain%20road%20at%20dusk%20with%20a%20single%20street%20lamp%2C%20mist%20over%20forested%20hills%2C%20muted%20brown%20and%20olive%20tones%2C%20atmospheric%20documentary%20landscape%2C%20artistic%20painterly%20style%2C%20soft%20grain%2C%20no%20people%2C%20restrained%20and%20serious%20mood&width=800&height=600&seq=mnhl-story-02&orientation=landscape',
  },
  {
    name: '阿哲',
    meta: '19 岁 · 辍学青年',
    place: '三次转运 · 已脱身',
    summary: '被反复转手，他靠记住路牌与作息规律，等到了唯一一次机会，也把这段经历原原本本讲了出来。',
    tags: ['反复转卖', '等待时机'],
    img: 'https://readdy.ai/api/search-image?query=Stylized%20close%20view%20of%20hands%20holding%20a%20paper%20boarding%20pass%20and%20a%20phone%20with%20dim%20screen%2C%20warm%20low%20light%2C%20muted%20amber%20and%20clay%20tones%2C%20documentary%20still%20life%2C%20soft%20grain%2C%20shallow%20depth%20of%20field%2C%20calm%20serious%20mood&width=800&height=600&seq=mnhl-story-03&orientation=landscape',
  },
  {
    name: '匿名受访者',
    meta: '26 岁 · 待业',
    place: '境外滞留 5 个月',
    summary: '家人的求助与他本人的自救同时展开，这段经历后来被整理成了一份按时间排列的流程复盘。',
    tags: ['家属求助', '流程复盘'],
    img: 'https://readdy.ai/api/search-image?query=Stylized%20empty%20dormitory%20room%20with%20metal%20bunk%20beds%20and%20a%20small%20window%2C%20dim%20afternoon%20light%2C%20muted%20grey%20brown%20and%20warm%20tones%2C%20quiet%20documentary%20interior%2C%20soft%20grain%2C%20no%20people%2C%20somber%20restrained%20atmosphere&width=800&height=600&seq=mnhl-story-04&orientation=landscape',
  },
];

export const schemePairs = [
  {
    claim: '“月薪两三万，包机票、包住宿。”',
    truth: '高薪与低门槛同时出现时，工作内容往往经不起核对。先确认用工主体、合同与签证类型，再谈出发。',
  },
  {
    claim: '“先过去，证件公司统一保管。”',
    truth: '代管身份证、护照与手机是被控制的前置信号。正常用工不会长期扣留个人证件，这一点没有例外。',
  },
  {
    claim: '“内容很简单，打字聊天就行。”',
    truth: '以“聊天、推广、数据录入”为名的岗位，很可能指向话术型诱骗工作，务必问清服务的对象与产品。',
  },
  {
    claim: '“不满意随时可以走。”',
    truth: '一旦出现限制出入、扣发报酬的情况，所谓“随时可走”通常会变成层层阻拦，口头承诺并不可信。',
  },
  {
    claim: '“先垫付路费，到岗就报销。”',
    truth: '垫付机票与食宿费用后，对方就同时握住了你的沉没成本与谈判筹码，这本身就是一种施压方式。',
  },
];

export const faqs = [
  {
    q: '这类口述档案的内容来源是什么？',
    a: '主要来自脱身者的口述整理、家属提供的求助记录，以及公开报道中的事实要素。内容用于反诈警示与安全教育，不指向具体个人。',
  },
  {
    q: '如果亲友疑似被困境外，第一步该做什么？',
    a: '先确认最后一次联系的时间与位置信息，完整保存聊天记录与转账凭证，再通过正规求助渠道同步信息。不建议自行前往，也不要轻信所谓“中间人”。',
  },
  {
    q: '已经被要求交出证件和手机，怎么办？',
    a: '尽量不要正面冲突，优先保证自身安全。留意身边可辨认的位置特征与作息规律，寻找安全的联络时机，为后续求助留下有效信息。',
  },
  {
    q: '遇到“境外高薪招聘”如何快速判断风险？',
    a: '重点看三点：是否低门槛却高薪、是否要求垫付费用、是否由非正规渠道对接。三项同时出现时，风险极高。',
  },
  {
    q: '家人一直联系不上，多久应该求助？',
    a: '不必等到固定的期限。一旦出现异常失联、行程说法前后不一致等迹象，就应尽早整理信息并求助。',
  },
];

export const warningPoints = [
  { icon: 'ri-search-eye-line', text: '任何“低门槛高薪”的境外岗位，先核实用工主体、合同与签证类型。' },
  { icon: 'ri-passport-line', text: '不把身份证、护照原件交给非官方机构长期保管，证件始终应在自己手中。' },
  { icon: 'ri-share-forward-line', text: '出境前把行程、联系人信息同步给至少两位家人，并约定固定的报平安时间。' },
  { icon: 'ri-folder-shield-2-line', text: '完整保存招聘方的聊天记录、转账凭证与联系方式，救助时都用得上。' },
  { icon: 'ri-map-pin-time-line', text: '一旦被限制人身自由，优先记住位置特征与作息规律，避免正面冲突。' },
];

export const footerColumns = [
  {
    title: '口述档案',
    links: [
      { label: '亲历者时间线', href: '#timeline' },
      { label: '经历与细节', href: '#stories' },
      { label: '逃生过程复盘', href: '#stories' },
    ],
  },
  {
    title: '识别与自查',
    links: [
      { label: '骗局识别清单', href: '#scheme' },
      { label: '出发前警示要点', href: '#warning' },
      { label: '警示问答', href: '#faq' },
    ],
  },
  {
    title: '求助入口',
    links: [
      { label: '资源入口导航', href: '#entry' },
      { label: '下载自查手册', href: '#cta' },
      { label: '求助与通报指引', href: '#cta' },
    ],
  },
];